import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBrackets2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"brackets-2"} maskId="square-filled-radius-0-stroke-1-IconBrackets2"><path fillRule="evenodd" clipRule="evenodd" d="M4 3H9V4H5V20H9V21H4V12.5H2V11.5H4V3ZM15 3H20V11.5H22V12.5H20V21H15V20H19V4H15V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBrackets2;
